import template from './sendDocuments.template.html';
import templateTicketViewSendEMail from '../ticket/ticketViewSendEmail.template.html';

export default {
  template,
  bindings: {
    onFinished: '&',
    idTicket: '<',
    lender: '<',
    contacts: '<',
    isTicketView: '<',
    lenderAssignedId: '<',
    liabilities: '<',
    lenders: '<'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $mdDialog,
      $mdMedia,
      Contact,
      ticketService,
      accountService,
      messagesService,
      lodgementService,
      uiService
    ) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$rootScope = $rootScope;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = () => {
        ctrl.idTicket = ctrl.idTicket || '';
        ctrl.contacts = ctrl.contacts || [];
        ctrl.lenderAssignedId = ctrl.lenderAssignedId || '';
        ctrl.liabilities = (ctrl.liabilities || []).filter(
          (l) => l.isRefinanced && l.liabilityType.id === 'mortgage_loan'
        );
        ctrl.lenders = ctrl.lenders || [];

        const showEmail = (lender, type, details) =>
          lender.abbr === ctrl.lender.abbr
            ? type === 'EMAIL_FOR_SUPPORTING_DOCUMENT' && details
            : type === 'EMAIL_FOR_DISCHARGE_AUTHORITY' && details;

        ctrl.lendersForDocuments = ctrl.lenders
          .filter(
            (l) =>
              ctrl.lender.abbr === l.abbr ||
              ctrl.liabilities.some((liab) => l.abbr === liab.name.toUpperCase())
          )
          .map((l) => ({
            name: l.name,
            isCurrentLender: ctrl.lender.abbr === l.abbr,
            contact: l.contact.filter(({ type, details }) => showEmail(l, type, details))
          }))
          .filter((l) => l.contact.length > 0);
      };

      this.sendEmail = async ($event, lenderContact) => {
        $event.stopPropagation();

        ctrl.ticket = await ticketService.readTicket({ id: ctrl.idTicket });

        const [currentTicketOwner, currentAttachments, currentMessages] = await Promise.all([
          accountService.readAccount({ id: ctrl.ticket.idOwner }),
          ticketService.getAttachments(ctrl.ticket),
          messagesService.getAvailable({ type: ['email'] })
        ]);

        ctrl.ticketOwner = currentTicketOwner;
        ctrl.attachments = currentAttachments;
        ctrl.messages = currentMessages;

        const result = await $mdDialog.show({
          targetEvent: $event,
          locals: {
            ticket: ctrl.ticket,
            ticketOwner: ctrl.ticketOwner,
            attachments: ctrl.attachments,
            messages: ctrl.messages
          },
          template: templateTicketViewSendEMail,
          controllerAs: '$ctrl',
          controller(ticket, ticketOwner, attachments, messages) {
            const self = this;

            self.type = 'lender_documents';
            self.email = {};
            self.ticket = ticket;
            self.account = $rootScope.CurrentAccount;
            self.ticketOwner = ticketOwner;
            self.attachments = attachments;
            self.messages = messages;

            self.supportingDocumentEmail = lenderContact.details;

            self.contact = Contact.build({
              id: '',
              idOwner: self.account.id,
              person: {
                information: {
                  firstName: lenderContact.name
                },
                contact: {
                  email: self.supportingDocumentEmail
                }
              }
            });

            self.limit = 16;
            self.showMoreAttachments = false;
            self.email.attachments = [];
            self.email.subject = `${
              ctrl.lenderAssignedId ? `${ctrl.lenderAssignedId} ` : ''
            }${ctrl.contacts.map((contact) => contact.getName()).join(' & ')}`;
            self.email.idSender = self.ticketOwner.id;
            self.email.idWorkflow = self.ticket.idWorkflow;
            self.email.idTicket = self.ticket.id;
            self.email.email = self.supportingDocumentEmail.trim();

            self.isSenderDisabled = () => !self.ticket;

            for (let a = 0; a < self.attachments.length; a += 1) {
              self.attachments[a].isSelected = false;
            }

            self.addMessage = (message) => {
              self.email.subject = message.subject;
              self.email.content = message.content;
            };

            self.select = (selectedAttachment) => {
              const attachment = selectedAttachment;
              attachment.isSelected = !attachment.isSelected;
              const idx = _.findIndex(self.email.attachments, (a) => a.id === attachment.id);
              if (idx === -1) {
                self.email.attachments.push(attachment);
              } else {
                self.email.attachments.splice(idx, 1);
              }
            };

            self.toggleShowMore = () => {
              self.showMoreAttachments = !self.showMoreAttachments;
              self.limit = self.showMoreAttachments ? undefined : 16;
            };

            self.confirm = () => {
              if (self.email.subject && self.email.content) {
                $mdDialog.hide(self.email);
              } else {
                uiService.toast({
                  text: {
                    p1: 'Email subject and content',
                    p2: 'are required fields',
                    p3: 'and cannot be empty'
                  },
                  warn: true
                });
              }
            };

            self.cancel = () => {
              $mdDialog.cancel();
            };
          }
        });

        const response = await lodgementService.sendDocuments({
          idWorkflow: result.idWorkflow,
          idTicket: result.idTicket,
          idSender: result.idSender,
          subject: result.subject,
          content: result.content,
          attachments: result.attachments,
          email: result.email
        });

        uiService.toast({
          text: {
            p1: 'E-mail',
            p2: result.subject,
            p3: response.status ? 'has been sent' : 'could not be sent'
          },
          warn: !response.status,
          success: response.status
        });

        ctrl.onFinished({ status: response.status });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = () => {
        this.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = () => {};

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      this.$onDestroy = () => {};
    }
  }
};
